let param = window.location.href.split("?")[1];
let getUrl = document.querySelectorAll('.js-nextLink');
let len = getUrl.length;
let getTabUrl = document.querySelectorAll('.js-tabLink');
let tabUrlLen = getTabUrl.length;

if(param) {
  let paramFilter = param.replace('#main', '');

  for(let i = 0; i < len; i++) {
    let href = getUrl[i].href;
    getUrl[i].href = href + '?' + paramFilter;
  }

  for(let i = 0; i < tabUrlLen; i++) {
    let href = getTabUrl[i].href;
    getTabUrl[i].href = href + '?' + paramFilter + '#main';
  }

} else {

  for(let i = 0; i < tabUrlLen; i++) {
    let href = getTabUrl[i].href;
    getTabUrl[i].href = href + '#main';
  }
}
